export default "__VITE_ASSET__CMxa3tCd__"